import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";

interface IBubbleChart {
  data?: any;
  highcharts?: any;
  backgroundColor?: string;
  width?: number;
  height?: number;
}
const BubbleChart: React.FC<IBubbleChart> = (props: IBubbleChart) => {
  const { highcharts, data, width, height, backgroundColor } = props;
  let entities = data?.map((item: any) => ({ y: item.relevance, name: item.entity }));

  const options = {
    chart: {
      type: "bubble",
      chart: {
        type: "pie",
        height: height,
        width: width,
        backgroundColor: backgroundColor ?? `rgba(0, 0, 0, 0)`,
      },
    },
    legend: {
      enabled: false,
    },
    title: { useHTML: true, text: `<h4>ENTITIES</h4>` },
    accessibility: {
      point: {
        valueDescriptionFormat: "{point.name}",
      },
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: "{point.name}",
        },
      },
    },

    series: [
      {
        data: entities,
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
  };
  useEffect(() => {
    highcharts.chart("container", options);
  }, [entities]);

  return (
    <Wrapper>
      <div id="container" className="container-div" />
    </Wrapper>
  );
};

export default React.memo(BubbleChart);

const Wrapper = styled.div`
  background: white;
  border-radius: 10px !important;
  box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);
  .container-div {
    border-radius: 10px !important;
  }
  .highcharts-title {
    top: 24px !important;
    left: 24px !important;
  }
  h4 {
    font-family: "Roboto Slab";
    font-weight: bold;
    font-size: 28px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 28px;
    }
  }
`;
